const Brand = ({ className }: { className?: string }) => {
  return <div className={`${className}`}>Brand</div>;
};

export { Brand };
